import React from 'react'
import SubPersonPageDecoratorSkeleton from '../common/SubPersonPageDecoratorSkeleton'
import SourceGridSkeleton from './SourceGridSkeleton'

export default function SourceGridPageSkeleton(): JSX.Element {
  return (
    <SubPersonPageDecoratorSkeleton maxWidth="xl">
      <SourceGridSkeleton />
    </SubPersonPageDecoratorSkeleton>
  )
}
